const AcceptedFileTypes = {
  imageOnly: "image/png, image/jpg, image/jpeg",
  videoOnly: "video/mp4",
  imageAndVideo: "video/mp4, image/png, image/jpg, image/jpeg",
  svgOnly: "image/svg+xml",
};

module.exports = { data: AcceptedFileTypes };
